import * as JobBoardSearchInterfaceModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/job-boards-search-interface-modal.html';
import * as JobBoardSearchHistoryModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/job-boards-search-history-modal.html';
var JobBoardsSupportedParametersController = /** @class */ (function () {
    /*@ngInject*/
    function JobBoardsSupportedParametersController($uibModal, $sce, $timeout, jobService, modalService) {
        this.$uibModal = $uibModal;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.jobService = jobService;
        this.modalService = modalService;
    }
    JobBoardsSupportedParametersController.prototype.$onInit = function () {
        //variables
        this.isJobBoardSelected = false;
        this.isGetCandidateFetchCalled = false;
        this.savingFlag = false;
    };
    JobBoardsSupportedParametersController.prototype.onJobBoardSelectionChange = function () {
        this.jobBoardsSelectionChange();
    };
    JobBoardsSupportedParametersController.prototype.clearJobBoardsSearchFilters = function () {
        var _this = this;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: "Are you sure you want clear the advanced filters?",
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this.jobService.removeDaxtraParameters(_this.job.id, function (data) {
                        _this.job.daxtraParameters = null;
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                            message: "Job Boards Filters Cleared Successfully",
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            },
                            callback: function () {
                                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                            }
                        });
                    }, function (error) {
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-danger' style='margin-bottom: 0px;'><i class='fa fa-alert fa-fw fa-lg'></i><strong>Error!</strong></div>",
                            message: "Job Boards Filters Clear Failed",
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            },
                            callback: function () {
                                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                            }
                        });
                    });
                }
                else {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            }
        });
    };
    JobBoardsSupportedParametersController.prototype.getJobBoardSearchInterface = function () {
        var _this = this;
        var jobBoardCodes = '';
        angular.forEach(this.job.jobBoardDetails, function (val, key) {
            if (val.enabled) {
                jobBoardCodes = jobBoardCodes == '' ? val.daxtraCode : jobBoardCodes + ',' + val.daxtraCode;
            }
        });
        if (jobBoardCodes == '') {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Job Boards Selected!</strong></div>",
                message: "Please select at least one job board to perform this action.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
        else {
            var ctrl_1 = this;
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                template: JobBoardSearchInterfaceModalTemplate.default,
                controller: ['$uibModalInstance', '$sce', '$timeout', 'jobId', 'jobBoardCodes', 'jobService', 'modalService', 'alertsAndNotificationsService', function ($uibModalInstance, $sce, $timeout, jobId, jobBoardCodes, jobService, modalService, alertsAndNotificationsService) {
                        var _this = this;
                        var vm = this;
                        vm.loadingSearchInterfaceFlag = true;
                        vm.savingFlag = false;
                        vm.jobId = jobId;
                        vm.location = location;
                        vm.searchHtml = '';
                        var searchObject = {};
                        searchObject.dbCode = 'jw_fourdotfive';
                        searchObject.jobBoardCodes = jobBoardCodes;
                        searchObject.jsLib = 'jquery';
                        searchObject.libs = 'css,jb_params_jq,jquery-ui';
                        searchObject.ajaxAutoCompleter = 'http://jbws-az-4dot5.daxtra.com/rtb/spider_params_completer.pl';
                        searchObject.ajaxUpdater = 'http://jbws-az-4dot5.daxtra.com/rtb/spider_params_ajax.pl';
                        searchObject.jsonp = true;
                        searchObject.relayParam = 'daxtra.com';
                        jobService.getJobBoardSearchInterface(searchObject, function (data) {
                            vm.searchHtml = $sce.trustAsHtml(data.t.htmlContent);
                            // data.t.jsContent = data.t.jsContent.replace("<select", "<select class='color-red'");
                            var searchJobParamsJS = "<script>" + data.t.jbParamsJq + "</script>";
                            var searchJS = "<script>" + data.t.jsContent + "</script>";
                            var searchCSS = "<style>" + data.t.cssContent + "</style>";
                            $('#dynamicContentForJobBoardSearch').append(searchCSS);
                            $('#dynamicContentForJobBoardSearch').append(searchJobParamsJS);
                            $('#dynamicContentForJobBoardSearch').append(searchJS);
                            vm.loadingSearchInterfaceFlag = false;
                            $timeout(function () {
                                // remove the 'max results' labels and selection boxes.
                                // remove labels
                                $("label:contains('Max results')").remove();
                                // remove select controls
                                $("select[name$='_max_results']").remove();
                            }, 500);
                        }, function (error) {
                            vm.loadingSearchInterfaceFlag = false;
                            alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                        vm.closeModal = function () {
                            $uibModalInstance.close('cancel');
                        };
                        vm.saveCallback = function (locationObject) {
                            vm.closeModal();
                            updateLocationCallback(locationObject);
                        };
                        vm.loadDaxtraParametersAndImage = function (params, image) {
                            ctrl_1.loadDaxtraParametersAndImage(params, image);
                        };
                        vm.saveAdvancedSearchParams = function () {
                            vm.savingFlag = true;
                            var advancedSearchArray = $("#jobBoardSearchForm").serializeArray();
                            var advancedSearchObject = {};
                            angular.forEach(advancedSearchArray, function (val, key) {
                                advancedSearchObject[val['name']] = val['value'];
                            });
                            $("#daxtra-ui").scrollTop("0px");
                            $timeout(function () {
                                var getCanvas;
                                html2canvas(document.querySelector("#jb_params")).then(function (canvas) {
                                    getCanvas = canvas;
                                    var imageData = getCanvas.toDataURL("image/png");
                                    advancedSearchObject.image = imageData.replace(/^data:image\/png/, "data:application/octet-stream");
                                    jobService.saveDaxtraParameters(_this.jobId, advancedSearchObject, function (data) {
                                        vm.savingFlag = false;
                                        bootbox.alert({
                                            closeButton: false,
                                            title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                                            message: "<span>Advanced Search Parameters saved successfully.</span></br> <span>Hit 'Next' to initiate search and pull candidates.</span>",
                                            className: "zIndex1060",
                                            buttons: {
                                                ok: {
                                                    label: 'Ok',
                                                    className: 'btn-info'
                                                }
                                            },
                                            callback: function () {
                                                vm.closeModal();
                                                ctrl_1.loadDaxtraParametersAndImage(data.daxtraParameters, data.advancedParametersImage);
                                            }
                                        });
                                    }, function (error) {
                                        vm.savingFlag = false;
                                        alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    });
                                });
                            }, 2000);
                        };
                    }],
                controllerAs: 'searchModal',
                size: 'lg',
                resolve: {
                    jobId: function () {
                        return ctrl_1.job.id;
                    },
                    jobBoardCodes: function () {
                        return jobBoardCodes;
                    }
                }
            });
        }
    };
    JobBoardsSupportedParametersController.prototype.loadDaxtraParametersAndImage = function (params, image) {
        this.job.daxtraParameters = params;
        this.job.advancedParametersImage = this.$sce.trustAsResourceUrl(image);
    };
    JobBoardsSupportedParametersController.prototype.launchJobBoardSearchHistory = function () {
        var clientOrBuName = '';
        if (!_.isNull(this.job.clientorbu)) {
            clientOrBuName = this.job.clientorbu.name;
        }
        var ctrl = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            template: JobBoardSearchHistoryModalTemplate.default,
            windowClass: 'four-dot-five-modal-medium',
            controller: ['$uibModalInstance', 'jobId', 'clientOrBuName', 'jobTitle', function ($uibModalInstance, jobId, clientOrBuName, jobTitle) {
                    var _this = this;
                    var vm = this;
                    this.jobId = jobId;
                    this.clientOrBuName = clientOrBuName;
                    this.jobTitle = jobTitle;
                    this.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    this.saveCallback = function () {
                        _this.closeModal();
                    };
                }],
            controllerAs: 'searchHistoryModal',
            resolve: {
                jobId: function () {
                    return ctrl.job.id;
                },
                clientOrBuName: function () {
                    return clientOrBuName;
                },
                jobTitle: function () {
                    return ctrl.job.title;
                }
            }
        });
    };
    return JobBoardsSupportedParametersController;
}());
JobBoardsSupportedParametersController.$inject = ['$uibModal', '$sce', '$timeout', 'jobService', 'modalService'];
// import * as TEMPLATE from './job-boards-supported-parameters.html';
import * as TEMPLATE from 'raw-loader!./job-boards-supported-parameters.html';
export var JobBoardsSupportedParametersComponent = {
    selector: 'jobBoardsSupportedParameters',
    component: {
        bindings: {
            job: '=',
            isEditable: '=',
            readOnlyJobBoardsData: '=',
            resumePullOptions: '=',
            radiusOptions: '=',
            recencyOptions: '=',
            resumePullOptions: '=',
            savedResumePullCount: '=',
            activeFilterTab: '=',
            saveCallback: '&',
            jobBoardsSelectionChange: '&',
            context: '@'
        },
        controller: JobBoardsSupportedParametersController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/job-boards-supported-parameters.html'
    }
};
//# sourceMappingURL=job-boards-supported-parameters.component.js.map